import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UploadFile } from './upload.service';

@Component({
	selector: 'app-upload-status-dialog',
	templateUrl: 'upload-status.dialog.html',
	styleUrls: ['./upload-status.dialog.css']
})
// tslint:disable-next-line: component-class-suffix
export class UploadStatusDialog implements OnInit {

	uploadList: UploadFile[];

	constructor(
		private dialogRef: MatDialogRef<UploadStatusDialog>,
		@Inject(MAT_DIALOG_DATA) _data: any) {
			this.uploadList = _data as UploadFile[];

			if (this.uploadList) {
				this.uploadList.forEach(uploadFile => {
					uploadFile.subject.subscribe(() => {}, () => {}, () => {
						let isAllCompleted = true;
						for (const currentUpload of this.uploadList) {
							if (currentUpload.progress !== 100) {
								isAllCompleted = false;
								break;
							}
						}
						// if (isAllCompleted) {
						// 	dialogRef.close({
						// 		result: true
						// 	});
						// }
					});
				});
			}
		}

	ngOnInit() {
	}

	onClose(): void {
		this.dialogRef.close({
			result: false
		});
	}

}

